import { render, staticRenderFns } from "./BrainstormVotingSticker.vue?vue&type=template&id=2df7f5be&scoped=true&"
import script from "./BrainstormVotingSticker.vue?vue&type=script&lang=js&"
export * from "./BrainstormVotingSticker.vue?vue&type=script&lang=js&"
import style0 from "./BrainstormVotingSticker.vue?vue&type=style&index=0&id=2df7f5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7f5be",
  null
  
)

export default component.exports